import { render } from "./StockRegister.vue?vue&type=template&id=9323c3fa&scoped=true"
import script from "./StockRegister.vue?vue&type=script&lang=js"
export * from "./StockRegister.vue?vue&type=script&lang=js"

import "./StockRegister.vue?vue&type=style&index=0&id=9323c3fa&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9323c3fa"]])

export default __exports__